import { SfLog } from '@app/adapters/logger'

// Re-sends traits to Appcues after a mid-session state change, since the
// tracker partial's identify() only runs on a full page load. Traits are
// merged by Appcues. Covers both the direct Appcues and Segment-mediated
// paths — either or both may be present depending on firm config.
export function reidentifyAppcuesUser(
  traits: Record<string, string | number | boolean | null>,
  errorLabel: string
): void {
  try {
    const userId = window.Silverfin.currentGlobalUserId()

    if (window.Appcues?.identify) {
      window.Appcues.identify(userId, traits)
    }

    if (window.analytics?.identify) {
      void window.analytics.identify(userId, traits)
    }
  } catch (error) {
    SfLog.warn(errorLabel, { error })
  }
}
